<template>
  <div>
    <div class="modal-content-wrap">
      <div class="lego-select-search">
        <div class="lego-text-field-wrapper" style="width: 100%">
          <lego-text-field
            searchable
            ref="input"
            v-model="searchText"
            :placeholder="getPlaceHolder"
            counter="100"
            @click-icon="searchFields"
            @enter="searchFields"
            :isCounter="false"
          />
        </div>
      </div>
      <AddMonitorTargetSubItem
        v-if="isExistSubItem"
        ref="subItem"
        :searchText="textSearch"
        :searchDate="searchDate"
        :monitorInfo="monitorInfo"
        :objectTypeName="objectTypeName"
        :scrollMaxRow="13"
        :height="480"
        @onCheck="onCheck"
      >
      </AddMonitorTargetSubItem>
      <AddMonitorTargetItem
        v-else
        ref="monTargetItem"
        :searchText="textSearch"
        :monitorInfo="monitorInfo"
        :height="500"
        :scrollMaxRow="13"
        :selected="selected"
        @onCheck="onCheck"
        @clearSearchText="clearSearchText"
      >
      </AddMonitorTargetItem>
    </div>
  </div>
</template>
<script>
import { checkObjectTypesNonSub } from '@/containers/utils/utils.js';
import AddMonitorTargetItem from '@/containers/performance/AddMonitorTargetItem.vue';
import AddMonitorTargetSubItem from '@/containers/performance/AddMonitorTargetSubItem.vue';
import validateSearchMixin from '@/mixins/validateSearch.mixin';

export default {
  name: 'AddMonitorTargetDialog',
  mixins: [validateSearchMixin],
  props: {
    monitorInfo: {
      type: Object,
      default: () => {
        return {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: '',
          pObjectTypeName: ''
        };
      }
    },
    searchDate: {
      type: Object
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AddMonitorTargetItem,
    AddMonitorTargetSubItem
  },
  computed: {
    isExistSubItem() {
      let { pProductTypeCode, pObjectTypeCode } = this.monitorInfo;
      return checkObjectTypesNonSub(pProductTypeCode, pObjectTypeCode);
    },
    getPlaceHolder() {
      return this.monitorInfo.pProductTypeCode === 'WAN'
        ? this.$t('searchLabel.searchLike', { VPC: this.$t('searchLabel.attachmentName') })
        : this.$t('searchLabel.searchLike', { VPC: this.$t('searchLabel.monTarget') });
    }
  },
  data() {
    return {
      objectTypeCode: '',
      searchText: '',
      objectTypeList: [],
      allCardList: [],
      objectTypeName: '',
      textSearch: ''
    };
  },
  created() {
    this.popupInit();
  },
  watch: {
    allCardList: {
      deep: true,
      handler() {
        this.$emit('change-list-chip', this.allCardList);
      }
    }
  },
  methods: {
    clearSearchText() {
      this.searchText = '';
      this.textSearch = '';
    },
    async popupInit() {
      if (this.monitorInfo.pObjectTypeCode) {
        this.objectTypeCode = this.monitorInfo.pObjectTypeCode;
        this.objectTypeList = await this.$http.product.getListProductObjectTypes(
          this.monitorInfo.pProductTypeCode
        );
        this.objectTypeName = this.objectTypeList.find((o) => o.value === this.objectTypeCode).text;
      }
    },
    deleteCard(delType, item) {
      if (this.isExistSubItem) {
        this.$refs.subItem.deleteCard(item);
      }
    },
    onCheck(selectedItems) {
      this.allCardList = selectedItems;
      this.$emit('selected-items', selectedItems);
    },
    searchFields() {
      this.textSearch = this.searchText;
      this.$refs.monTargetItem?.execSearch(true, this.textSearch);
      this.$refs.input.blur();
    },
    resetSearchField() {
      this.searchText = '';
      this.textSearch = '';
      this.$refs.monTargetItem?.execSearch(true);
    },
    execSearch() {
      this.$refs.monTargetItem?.execSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content-wrap {
  max-width: 1000px;

  .lego-table-wrap {
    padding: 14px 0 0 0;
  }
}

.lego-select-search {
  width: 100%;
}

.modal-cotent-wrap {
  max-width: 1000px;
}

.badge-text-wrapper {
  display: flex;
  align-items: center;
}

::v-deep .listTargetItem {
  display: inline-block;
  color: #364fc7;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

::v-deep .scpmSubTitleContainer .scpmSubTitle {
  font-size: 14px !important;
}

.scpm-drag-wrap {
  padding-top: 20px;
}

::v-deep .added-list-box {
  margin-top: 5px !important;
}
</style>
